<template>
<div class="chapter">
<div class="inner_page">
<blockquote><p class="center"><a id="pvi"></a> "<em>Affliction comes to us, not to make us sad, but sober, not to make us sorry, but wise.</em>"</p></blockquote><blockquote><p class="center">—Henry Ward Beecher</p></blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?67a6a8f9